// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import { SectionInput } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/fields/SectionInput/SectionInput';
import { InstructionResult } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/fields/InstructionResult/InstructionResult';
import TextFormFieldPreview from '../TextFormFieldPreview';
import NumberFormFieldPreview from '../NumberFormFieldPreview';
import UploadFormFieldPreview from '../UploadFormFieldPreview';
import DateFormFieldPreview from '../DateFormFieldPreview';
import YesNoNaFormFieldPreview from '../YesNoNaFormFieldPreview';
import MultipleSelectFieldPreview from '../MultipleSelectFieldPreview';
import { useStyles } from '../../style';
import ImageUploadFormFieldPreview from '../ImageUploadFormFieldPreview';
import CheckboxFormFieldPreview from '../CheckboxFormFieldPreview';
import EmailFormFieldPreview from '../EmailFormFieldPreview';
import TimeFormFieldPreview from '../TimeFormFieldPreview';
import DateTimeLocalFormFieldPreview from '../DateTimeLocalFormFieldPreview';
import { MultiSignatureFormFieldPreview } from '../MultiSignatureFormFieldPreview/MultiSignatureFormFieldPreview';
import TableFormFieldPreview from '../TableFormFieldPreview';
import { SignatureFieldPreview } from '../SignatureFieldPreview/SignatureFieldPreview';
import { CannotBePrefilledElement } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/CannotBePrefilledElement';

const FormFieldPreview = ({
  element,
  answer,
  handleAnswerChange,
  error,
  field,
  isPreview,
  updateAnswerInPrefilledElements = undefined,
  isPrefillEditable = true,
  prefilledElementIDs = [''],
}) => {
  const classes = useStyles();
  const [, { setIsResponseDirty }] = useCustomForm();
  const errorRef = useRef(null);
  // scroll to error
  useEffect(() => {
    if (errorRef.current && error) {
      errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [error, element]);
  const cardContentStyle = {
    wordWrap: 'break-word',
  };
  const errorText = {
    color: 'red',
    fontSize: '0.875rem',
    margin: '5px 0px 0px 10px',
  };
  const inputLabelStyle = {
    color: '#233759',
    fontWeight: '500',
    marginBottom: '8px',
    fontSize: '16px',
  };
  const handleDirty = () => {
    setIsResponseDirty(true);
  };
  const shouldBeReadOnly =
    !isPreview &&
    !isPrefillEditable &&
    (element?.type === 'table' || element?.type === 'advtable'
      ? true // condition for prefilled answer in table has been handled in the table cell preview
      : prefilledElementIDs.includes(element?.id));

  return (
    <Card
      key={element?.id}
      elevation={element?.type === 'section' ? 0 : 1}
      className={`${classes.previewCard} ${
        element?.type === 'section' ? classes.sectionCard : ''
      }`}
    >
      <CardContent align="left" style={cardContentStyle}>
        {(() => {
          switch (element?.type) {
            case 'text':
              return (
                <>
                  <TextFormFieldPreview
                    element={element}
                    answer={answer}
                    handleAnswerChange={handleAnswerChange}
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'email':
              return (
                <>
                  <EmailFormFieldPreview
                    element={element}
                    answer={answer}
                    handleAnswerChange={handleAnswerChange}
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'section':
              return <SectionInput item={element} />;
            case 'instruction':
              return <InstructionResult item={element} />;
            case 'phone':
            case 'number':
              return (
                <>
                  <NumberFormFieldPreview
                    element={element}
                    answer={answer}
                    handleAnswerChange={handleAnswerChange}
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'date':
              return (
                <>
                  <DateFormFieldPreview
                    element={element}
                    answer={answer}
                    updateAnswerInPrefilledElements={
                      updateAnswerInPrefilledElements
                    }
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    handleDirty={handleDirty}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'time':
              return (
                <>
                  <TimeFormFieldPreview
                    element={element}
                    answer={answer}
                    updateAnswerInPrefilledElements={
                      updateAnswerInPrefilledElements
                    }
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    handleDirty={handleDirty}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'datetimelocal':
              return (
                <>
                  <DateTimeLocalFormFieldPreview
                    element={element}
                    answer={answer}
                    updateAnswerInPrefilledElements={
                      updateAnswerInPrefilledElements
                    }
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    handleDirty={handleDirty}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'yesnona':
            case 'yesno':
            case 'radiogroup':
              return (
                <>
                  <YesNoNaFormFieldPreview
                    element={element}
                    answer={answer}
                    updateAnswerInPrefilledElements={
                      updateAnswerInPrefilledElements
                    }
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    handleDirty={handleDirty}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'multipleselect':
            case 'dropdown':
              return (
                <>
                  <MultipleSelectFieldPreview
                    element={element}
                    answer={answer}
                    updateAnswerInPrefilledElements={
                      updateAnswerInPrefilledElements
                    }
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    handleDirty={handleDirty}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'checkbox':
              return (
                <>
                  <CheckboxFormFieldPreview
                    element={element}
                    answer={answer}
                    updateAnswerInPrefilledElements={
                      updateAnswerInPrefilledElements
                    }
                    error={error}
                    inputLabelStyle={inputLabelStyle}
                    handleDirty={handleDirty}
                    shouldBeReadOnly={shouldBeReadOnly}
                  />
                  {error && (
                    <Typography style={errorText} ref={errorRef}>
                      {error}
                    </Typography>
                  )}
                </>
              );
            case 'files':
              return (
                <>
                  {updateAnswerInPrefilledElements ? (
                    <CannotBePrefilledElement element={element} />
                  ) : (
                    <>
                      <UploadFormFieldPreview
                        element={element}
                        answer={answer}
                        error={error}
                        inputLabelStyle={inputLabelStyle}
                        handleDirty={handleDirty}
                      />
                      {error && (
                        <Typography style={errorText} ref={errorRef}>
                          {error}
                        </Typography>
                      )}
                    </>
                  )}
                </>
              );
            case 'images':
              return (
                <>
                  {updateAnswerInPrefilledElements ? (
                    <CannotBePrefilledElement element={element} />
                  ) : (
                    <>
                      <ImageUploadFormFieldPreview
                        element={element}
                        answer={answer}
                        error={error}
                        inputLabelStyle={inputLabelStyle}
                        handleDirty={handleDirty}
                      />
                      {error && (
                        <Typography style={errorText} ref={errorRef}>
                          {error}
                        </Typography>
                      )}
                    </>
                  )}
                </>
              );
            case 'signature':
              return (
                <>
                  {updateAnswerInPrefilledElements ? (
                    <CannotBePrefilledElement element={element} />
                  ) : (
                    <>
                      <SignatureFieldPreview
                        element={element}
                        answer={answer}
                        error={error}
                        handleDirty={handleDirty}
                      />
                      {error && (
                        <Typography style={errorText} ref={errorRef}>
                          {error}
                        </Typography>
                      )}
                    </>
                  )}
                </>
              );
            case 'multisignature':
              return (
                <>
                  {updateAnswerInPrefilledElements ? (
                    <CannotBePrefilledElement element={element} />
                  ) : (
                    <>
                      <MultiSignatureFormFieldPreview
                        element={element}
                        answer={answer}
                        error={error}
                        inputLabelStyle={inputLabelStyle}
                        handleDirty={handleDirty}
                      />
                      {error && (
                        <Typography style={errorText} ref={errorRef}>
                          {error}
                        </Typography>
                      )}
                    </>
                  )}
                </>
              );
            case 'table':
            case 'advtable':
              return (
                <>
                  <TableFormFieldPreview
                    field={field}
                    error={error}
                    isPreview={isPreview}
                    updateAnswerInPrefilledElements={
                      updateAnswerInPrefilledElements
                    }
                    shouldBeReadOnly={shouldBeReadOnly}
                    prefilledElementIDs={prefilledElementIDs}
                  />
                  {error?.[field?.id] && (
                    <Typography style={errorText} ref={errorRef}>
                      {error[field?.id]}
                    </Typography>
                  )}
                </>
              );
            default:
              return null;
          }
        })()}
      </CardContent>
    </Card>
  );
};

export default FormFieldPreview;
